var exports = {
  "Qs": "ThemeAcceptModal.module__content___bmhmNV",
  "h_": "ThemeAcceptModal.module__description___bmhmNV",
  "Hy": "ThemeAcceptModal.module__codeContainer___bmhmNV",
  "AS": "ThemeAcceptModal.module__pre___bmhmNV",
  "Y4": "ThemeAcceptModal.module__hljs___bmhmNV",
  "lB": "ThemeAcceptModal.module__codeActions___bmhmNV",
  "vo": "ThemeAcceptModal.module__codeActionsVisible___bmhmNV",
  "cL": "ThemeAcceptModal.module__copyButton___bmhmNV",
  "nJ": "ThemeAcceptModal.module__copyIcon___bmhmNV",
  "KQ": "ThemeAcceptModal.module__loadingText___bmhmNV",
  "kc": "ThemeAcceptModal.module__errorText___bmhmNV",
  "qr": "ThemeAcceptModal.module__footer___bmhmNV",
};

module.exports = exports;
